import React, { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import Scroll from 'react-scroll';
import { useParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTasks, faTachometer, faPlus, faEye, faPencil, faBed, faCheckCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select'
import { useRecoilState } from 'recoil';

import { topAlertMessageState, topAlertStatusState } from "../../../AppState";
import { putSessionTemplateUpdateAPI } from "../../../API/SessionTemplate";
import { getSessionTemplateDetailAPI } from "../../../API/SessionTemplate";
import FormErrorBox from "../../Reusable/FormErrorBox";
import FormInputField from "../../Reusable/FormInputField";
import FormTextareaField from "../../Reusable/FormTextareaField";
import FormMultiSelectField from "../../Reusable/FormMultiSelectField";
import PageLoadingContent from "../../Reusable/PageLoadingContent";


function SessionTemplateSleepQuestionUpdate() {
    ////
    //// URL parameters.
    ////

    const { sid, sqIndex } = useParams()

    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [isFetching, setFetching] = useState(false);
    const [forceURL, setForceURL] = useState("");
    const [sessionTemplate, setSessionTemplate] = useState({});
    const [title, setTitle] = useState();
    const [subtitle, setSubtitle] = useState();

    ////
    //// Event handling.
    ////

    const onSubmitClick = (e) => {
        console.log("onSubmitClick: Beginning...");
        const modifiedSleepQuestion = {
            title: title,
            subtitle: subtitle,
        };
        console.log("onSubmitClick: Updating to sleep questions array...");
        for (let sleepQuestionIndex in sessionTemplate.sleepQuestions) {
            if (sleepQuestionIndex === sqIndex) {
                sessionTemplate.sleepQuestions[sleepQuestionIndex] = modifiedSleepQuestion;
            }
        }

        console.log("onSubmitClick: Payload:", sessionTemplate);

        console.log("onSubmitClick: Please wait");
        putSessionTemplateUpdateAPI(sessionTemplate, onSessionTemplateUpdateSuccess, onSessionTemplateUpdateError, onSessionTemplateUpdateDone);
    }

    ////
    //// API.
    ////

    function onSessionTemplateDetailSuccess(response){
        console.log("onSessionTemplateDetailSuccess: Starting...");
        console.log("onSessionTemplateDetailSuccess: sessionTemplate data:", response);
        setSessionTemplate(response);

        for (let sleepQuestionIndex in response.sleepQuestions) {
            if (sleepQuestionIndex === sqIndex) {
                let sleepQuestion = response.sleepQuestions[sleepQuestionIndex];

                console.log("Matched sleep question", sleepQuestion);
                setTitle(sleepQuestion.title);
                setSubtitle(sleepQuestion.subtitle);
            }
        }
    }

    function onSessionTemplateDetailError(apiErr) {
        console.log("onSessionTemplateDetailError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateDetailDone() {
        console.log("onSessionTemplateDetailDone: Starting...");
        setFetching(false);
    }

    function onSessionTemplateUpdateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionTemplateUpdateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Sleep question updated");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateSuccess: Delayed for 2 seconds.");
            console.log("onSessionTemplateUpdateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Redirect the user to a new page.
        setForceURL("/session-template/"+response.id+"/sleep-question/"+sqIndex);
    }

    function onSessionTemplateUpdateError(apiErr) {
        console.log("onSessionTemplateUpdateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionTemplateUpdateError: Delayed for 2 seconds.");
            console.log("onSessionTemplateUpdateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();

        // Reload the session template upon errors.
        setFetching(true);
        getSessionTemplateDetailAPI(
            sid,
            onSessionTemplateDetailSuccess,
            onSessionTemplateDetailError,
            onSessionTemplateDetailDone
        );
    }

    function onSessionTemplateUpdateDone() {
        console.log("onSessionTemplateUpdateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
            setFetching(true);
            getSessionTemplateDetailAPI(
                sid,
                onSessionTemplateDetailSuccess,
                onSessionTemplateDetailError,
                onSessionTemplateDetailDone
            );
        }

        return () => { mounted = false; }
    }, [sid]);

    ////
    //// Component rendering.
    ////

    if (forceURL !== "") {
        return <Navigate to={forceURL}  />
    }

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/session-templates" aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Templates</Link></li>
                            <li class=""><Link to={`/session-template/${sid}/sleep-questions`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Details (Sleep Questions)</Link></li>
                            <li class=""><Link to={`/session-template/${sid}/sleep-question/${sqIndex}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faBed} />&nbsp;Sleep Question</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faPencil} />&nbsp;Update</Link></li>
                        </ul>
                    </nav>
                    
                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/session-template/${sid}/sleep-question/${sqIndex}`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Sleep Question</Link></li>
                        </ul>
                    </nav>

                    {/* Content */}
                    <nav class="box">
                        <p class="title is-4"><FontAwesomeIcon className="fas" icon={faBed} />&nbsp;Sleep Question</p>
                        <FormErrorBox errors={errors} />

                        <p class="subtitle is-6">Details</p>

                        {isFetching && <PageLoadingContent displayMessage={"Please wait"} />}

                        {!isFetching && <div class="container">
                            <FormInputField
                                label="Title"
                                name="title"
                                type="text"
                                placeholder="Text input"
                                value={title}
                                errorText={errors && errors.title}
                                helpText=""
                                onChange={(e)=>setTitle(e.target.value)}
                                isRequired={true}
                                maxWidth="185px"
                            />

                            <FormInputField
                                label="Subtitle"
                                name="subtitle"
                                type="text"
                                placeholder="Text input"
                                value={subtitle}
                                errorText={errors && errors.subtitle}
                                helpText=""
                                onChange={(e)=>setSubtitle(e.target.value)}
                                isRequired={true}
                                maxWidth="375px"
                            />

                            <div class="columns">
                                <div class="column is-half">
                                    <Link to={`/session-template/${sid}/sleep-question/${sqIndex}`} class="button is-hidden-touch"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                    <Link to={`/session-template/${sid}/sleep-question/${sqIndex}`} class="button is-fullwidth is-hidden-desktop"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                </div>
                                <div class="column is-half has-text-right">
                                    <button class="button is-primary is-hidden-touch" onClick={onSubmitClick}><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                    <button class="button is-primary is-fullwidth is-hidden-desktop" onClick={onSubmitClick}><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                </div>
                            </div>

                        </div>}
                    </nav>
                </section>
            </div>
        </>
    );
}

export default SessionTemplateSleepQuestionUpdate;
